export const saveItemSession = (key, value) => {
  sessionStorage.setItem(key, value);
};
export const getItemSession = (key) => sessionStorage.getItem(key);
export const removeItemSession = (key) => sessionStorage.removeItem(key);

export const setLocalStorageItem = (key, value) =>
  localStorage.setItem(key, value);
export const getLocalStorageItem = (key) => localStorage.getItem(key);
export const removeLocalStorageItem = (key) => localStorage.removeItem(key);
